import { normalizeDate } from 'Utils/date/date.utils';
import { getAppText } from 'Utils/text';
import * as Yup from 'yup';

type IValidationObject = {
  futureCancelDate: Yup.DateSchema;
};

const futureCancelDateSchema = (
  maxDaysAllowed: number,
  shouldHaveFutureCancelDateFn: (cancelReason: unknown) => boolean,
): Yup.DateSchema => {
  const today = normalizeDate(new Date());
  const minDate = normalizeDate(new Date(today.setDate(today.getDate() + 1)));
  const maxDate = normalizeDate(
    new Date(today.setDate(today.getDate() + maxDaysAllowed - 1)),
  );

  return Yup.date().when('cancelReason', {
    is: (cancelReason: unknown): boolean => {
      return shouldHaveFutureCancelDateFn(cancelReason);
    },
    then: (schema) =>
      schema
        .required(getAppText('cancelForm.futureCancelDate.validation.required'))
        .typeError(getAppText('cancelForm.futureCancelDate.validation.format'))
        .min(minDate, getAppText('cancelForm.futureCancelDate.validation.min'))
        .max(
          maxDate,
          getAppText('cancelForm.futureCancelDate.validation.max', {
            insert: {
              max: maxDaysAllowed,
            },
          }),
        ),
    otherwise: (schema) => schema.notRequired(),
  });
};

export const futureCancelDateValidationObject = (
  maxDaysAllowed: number,

  shouldHaveFutureCancelDateFn: (cancelReason: unknown) => boolean,
): IValidationObject => {
  return {
    futureCancelDate: futureCancelDateSchema(
      maxDaysAllowed,
      shouldHaveFutureCancelDateFn,
    ),
  };
};
